
export function openJobFormModal (jobId, showModal) {
  import('./JobFormModal.vue')
    .then(async module => {
      const JobFormModal = module.default
      await showModal({
        component: JobFormModal,
        props: {
          itemId: jobId
        }
      })
    })
}
